export default "__VITE_ASSET__BX6Nuw2I__"